import { client } from '../apollo';
import { SEND_SUBSCRIPTION } from '../graphql';

export const subscribeToNotifications = async (subscriptionObject: any) => {
  const response: any = await client.mutate({
    mutation: SEND_SUBSCRIPTION,
    variables: {
      input: { subscription: subscriptionObject },
    },
  });

  return response;
};
